import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { version } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { Role } from '../../models/roles'
import { ConfigurationProvider } from '../../providers/configuration/configuration';


@IonicPage()
@Component({
  selector: 'page-configuration',
  templateUrl: 'configuration.html',
})
export class ConfigurationPage {

  public Role = Role;
  
  public pagesConfig: any = {};
  public pagesConfigSubscription;

  version = version;
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public configuration: ConfigurationProvider,
    public globalVars: GlobalVars,
  ) {
    this.pagesConfig.stateEnabled = false;
    this.pagesConfig.historyConfig = false;
    
    this.pagesConfigSubscription = this.configuration.getPagesConfig().subscribe(config => {
      if (config != null) {
        this.pagesConfig = config
      }
    })
  }

  ionViewWillLeave() {
    if (this.pagesConfigSubscription && !this.pagesConfigSubscription.closed) this.pagesConfigSubscription.unsubscribe();
  }

  toggleState() {
    this.configuration.setPagesConfig(this.pagesConfig)
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration.ts